export const EmbedStyle = Object.freeze({
  NONE: { key: 'none', name: 'None' },
  PAGE: { key: 'page', name: 'Page' },
  PANEL: { key: 'panel', name: 'Panel' },
})

export const LOCAL_STORAGE_OVERRIDES_KEY = 'launch_darkly_overrides'

export const API_BASE_URL = process.env.REACT_APP_AWSAPIGATEWAY;

export const env = 'prod' //udpateid
export const aptos_network = 'mainnet'

export const REDIRECT_URLS = {
  dev: 'https://local.backlotclub.com',
  stage: 'https://stage.backlot.club',
  uat: 'https://uat.backlotclub.com',
  prod: 'https://how-to-train-your-dragon.backlot.club'
};